<template>
  <div ref="textField">
    <div v-if="!isEditing || $attrs.readonly">
      <read-only-field
        :label="$attrs.label"
        :value="$attrs.value"
        v-bind="$attrs"
        @click="setEditMode($refs.textField)"
        data-testid="textFieldReadOnly"
      />
    </div>
    <div v-else>     
      <AdsTextField
        v-bind="$attrs"
        v-on="$listeners"
        data-testid="textField"
      />
    </div>
  </div>
</template>

<script>
import { AdsTextField } from '@/components/app/AdsTextField.vue'
import toggleFieldMixin from './toggleFieldMixin'

export default {
  name: 'TextField',
  mixins: [toggleFieldMixin],
  components: {
    AdsTextField
  }
}
</script>
